import { useLocation, useNavigate } from 'react-router-dom'

import {
  rememberAuthRedirect,
  safeRedirect,
  withRedirect,
} from '@/lib/redirect'

/**
 * Navigate to the branded sign-in / sign-up page, returning to the current
 * location after auth. Writes both the `?redirect_url=` param and the
 * sessionStorage bridge — see `@/lib/redirect`.
 */
export function useAuthRedirect() {
  const navigate = useNavigate()
  const location = useLocation()

  const go = (base: '/sign-in' | '/sign-up') => () => {
    const here = safeRedirect(`${location.pathname}${location.search}`)
    rememberAuthRedirect(here)
    void navigate(withRedirect(base, here))
  }

  return { goToSignIn: go('/sign-in'), goToSignUp: go('/sign-up') }
}
